import React from 'react';
import { Button } from '@components/ui/button';

export const ApplicantAddChildButton = ({
  title,
  onClick,
}: {
  title: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => {
  return (
    <Button
      className="w-full text-lg !font-secondary cursor-pointer hover:bg-white/70 xl:text-lg font-light justify-between px-4.5 xl:px-0  py-4 xl:py-4 h-auto flex items-center gap-x-8 text-black bg-white"
      onClick={onClick}
    >
      {title}
      <div className="relative xl:size-5 size-6 flex items-center justify-center">
        <span className="absolute w-full rounded-lg h-1 bg-primary"/>
        <span className="absolute w-1 h-full rounded-lg bg-primary"/>
      </div>
    </Button>
  );
};
